// https://capacitor.ionicframework.com/docs/apis/storage/
import { Storage } from "@core/plugins/mobile";

/**
 * StorageManager for all platforms with fallback on mobile
 * -> reasons why we don't use localstorage on mobile: https://github.com/TheCocoaProject/cordova-plugin-nativestorage#why
 * @class StorageManager
 */
export class StorageManager {
  /**
   * Get stored data by its key
   * @static
   * @param {String} key - the key of the stored resource
   * @returns {Promise}
   */
  static async getItem(key) {
    const ret = await Storage.plugin.get({ key });
    return JSON.parse(ret.value);
  }

  /**
   * Store data by its key
   * @static
   * @param {String} key - the key of the stored resource
   * @param {*} data - any type of object
   * @returns {Promise}
   */
  static setItem(key, data) {
    return Storage.plugin.set({ key, value: JSON.stringify(data) });
  }

  /**
   * Remove stored data by its key
   * @static
   * @param {String} key - the key of the stored resource
   * @returns {Promise}
   */
  static removeItem(key) {
    return Storage.plugin.remove({ key });
  }

  /**
   * Clear all stored data
   * @static
   */
  static clear() {
    return Storage.plugin.clear();
  }

  static getUserInfo(type) {
    const capuid = localStorage.getItem("_capuid");
    const userInfo = capuid !== null ? type : "inconnu";
    return userInfo;
  }
}
